export default __webpack_public_path__ + "MJt_jobSpecs.html";